<div class="background-tansparent url overflow-y-scroll">
	<ion-grid class="login-grid">
		<ion-row class="terra-info">
			<ion-col
				size="12"
				class="font-sans text-white text-3xl text-center font-bold"
				>Learn with Terra.do
			</ion-col>
			<ion-col
				size="12"
				class="font-sans text-white font-normal text-center text-center pt-8 pb-24"
				>Heads up! This login is only for Terra.do Fellows.
			</ion-col>
		</ion-row>
		<ion-row class="">
			<ion-col class="rightPanel" size="12">
				<router-outlet></router-outlet>
			</ion-col>
		</ion-row>
	</ion-grid>
</div>
